/** Where a ghost can hide behind the backdrop, in backdrop pixels. */
export interface Hide {
	name: string;
	/** The ghost's centre while hidden, fully behind the picture. */
	x: number;
	y: number;
	/** How far it slides out; its hem stays behind the picture. */
	dx: number;
	dy: number;
	/** How it leans while peeking out, in degrees clockwise (for the view). */
	tilt: number;
	/** Half its height, and how far from its centre a tap catches it (the tap's reach on top). */
	r: number;
}

/**
 * The hiding places behind public/assets/gfx/backdrop.png, measured on a grid overlay like the
 * spots. Only where transparent sky lies just beyond the picture's edge. A new picture needs new
 * measurements. The order is part of the game state: append only.
 */
export const HIDES: readonly Hide[] = [
	{ name: "Jacks hus, höger vägg", x: 605, y: 360, dx: 120, dy: 0, tilt: 20, r: 55 },
	{ name: "Jacks hus, vänster vägg", x: 545, y: 358, dx: -120, dy: 0, tilt: -20, r: 55 },
	{ name: "Jacks tak, höger", x: 636, y: 260, dx: 67, dy: -60, tilt: 48, r: 55 },
	{ name: "Jacks tak, vänster", x: 515, y: 306, dx: -98, dy: -86, tilt: -49, r: 55 },
	{ name: "Rådhusets tak, höger", x: 985, y: 466, dx: 60, dy: -104, tilt: 30, r: 55 },
	{ name: "Rådhusets tak, vänster", x: 820, y: 447, dx: -45, dy: -78, tilt: -30, r: 55 },
	{ name: "Månen, vänster", x: 106, y: 407, dx: -45, dy: -78, tilt: -30, r: 55 },
	{ name: "Månen, höger", x: 226, y: 432, dx: 72, dy: -54, tilt: 53, r: 55 },
];
